// JsFromRoutes CacheKey 66bfaad9597ae5518ace4a9c61c2bc43
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  save: definePathHelper('post', '/data'),
}
